export class CoinType {
    public static gold = new CoinType('gold', 'g', 100, 'gold talon', 'gold talons');
    public static silver = new CoinType('silver', 's', 25, 'silver shilling', 'silver shillings');
    public static copper = new CoinType('copper', 'c', 5, 'copper cret', 'copper crets');
    public static bit = new CoinType('bit', 'b', 1, 'bit (penny, bone or shard)', 'bits (pennies, bones or shards)');

    public static allCoinTypes: CoinType[] = [
        CoinType.gold, 
        CoinType.silver,
        CoinType.copper,
        CoinType.bit
    ];

    constructor(public name: string, public abbreviation: string, public valueInBits: number, public fullNameSingular: string, public fullnamePlural: string) {
    }
}